module.exports = __webpack_public_path__ + "img/bgLogin.b787ba77.jpg";